import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../../context/LocaleContext';
import { Toolbar, IconButton, Drawer, List, ListItem, ListItemText, Box, CssBaseline, ListItemButton, Stack } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DensitySmallOutlinedIcon from '@mui/icons-material/DensitySmallOutlined';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import LogoutIcon from '@mui/icons-material/Logout';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CurrencyExchangeRoundedIcon from '@mui/icons-material/CurrencyExchangeRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';

const BurgerMenu = () => {
	const { locale, changeLocale, messages } = useLocale();

	const [drawerOpen, setDrawerOpen] = useState(false);
	const Navigate = useNavigate();

	const handleDrawerToggle = () => {
		setDrawerOpen(!drawerOpen);
	};

	const menuItems = [
		{
			name: messages.navbar['all-in-one'],
			href: '/dashboard',
			icon: <DashboardRoundedIcon fontSize='medium' />
		},
		{
			name: messages.navbar['transaction'],
			href: '/transactions',
			icon: <CurrencyExchangeRoundedIcon fontSize='medium' />
		},
		{
			name: messages.navbar['inventory'],
			href: '/inventory',
			icon: <Inventory2OutlinedIcon fontSize='medium' />
		},
		{
			name: messages.navbar['barcode'],
			href: '/barcode',
			icon: <DensitySmallOutlinedIcon sx={{ transform: "rotate(90deg)"}} fontSize='medium'/>
		},
		{
			name: messages.navbar['report'],
			href: '/report',
			icon: <AssessmentRoundedIcon fontSize='medium' />
		},
		{
			name: messages.navbar['forecast'],
			href: '/forecast',
			icon: <TrendingUpRoundedIcon fontSize='medium' />
		},
		{
			name: messages.navbar['profile'],
			href: '/profile',
			icon: <AccountCircleRoundedIcon fontSize='medium' />
		},
		{
			name: messages.navbar['logout'],
			href: '/logout',
			icon: <LogoutIcon fontSize='medium' />
		},
	]

	return (
		<>
			<CssBaseline />
			<Toolbar>
				<IconButton
					edge="start"
					color="inherit"
					aria-label="menu"
					onClick={handleDrawerToggle}
					size="large"
				>
					<MenuIcon fontSize="large"/>
				</IconButton>
			</Toolbar>
			<Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle}>
				<Box
					sx={{ width: 250 }}
					role="presentation"
					onClick={handleDrawerToggle}
					onKeyDown={handleDrawerToggle}
				>
					<List>
						{menuItems.map((element, index) => (
							<ListItem key={index}>
								<ListItemButton onClick={() => Navigate(element.href)}>
									<Stack flexDirection='row' alignItems='center' gap={1}>
										{element.icon}
										<ListItemText primary={element.name} sx={{ textTransform: 'uppercase' }} />
									</Stack>
								</ListItemButton>
							</ListItem>
						))}
						<ListItem>
							<ListItemButton onClick={() => changeLocale()}>
								<Stack flexDirection='row' alignItems='center' gap={1}>
									<LogoutIcon fontSize='medium' />
									<ListItemText sx={{ textTransform: 'uppercase' }} primary='Change Locale' />
								</Stack>
							</ListItemButton>
						</ListItem>
					</List>
				</Box>
			</Drawer>
		</>
	);
};

export default BurgerMenu;
